import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import { Strong } from '@/components/rich-text-formatting';
import { TwoFactorAuthenticationType } from '@/legacy/features/user/twoFactorAuthentication/twoFactorAuthentication';

interface Props {
  isEnabled?: boolean;
  phoneNumber: string;
  verificationMethod: TwoFactorAuthenticationType;
}

const CodeMessage = (props: Props): React.JSX.Element => {
  const { isEnabled, phoneNumber, verificationMethod } = props;

  switch (verificationMethod) {
    case TwoFactorAuthenticationType.Sms:
      return (
        <Typography gutterBottom>
          {isEnabled ? (
            <FormattedMessage
              defaultMessage="We just sent a 6 digit verification code to the phone number associated with your two-step authentication. Enter this code in the field below to <Strong>DISABLE</Strong> your two-step authentication:"
              values={{ Strong }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="We just sent a 6 digit verification code to <Strong>{phoneNumber}</Strong> . Enter this code in the field below to enable your two-step authentication:"
              values={{ Strong, phoneNumber }}
            />
          )}
        </Typography>
      );

    case TwoFactorAuthenticationType.Otp:
      return (
        <Typography gutterBottom>
          {isEnabled ? (
            <FormattedMessage
              defaultMessage="Enter your verification code from your Authenticator App to <Strong>DISABLE</Strong> your two-step authentication:"
              values={{ Strong }}
            />
          ) : (
            <FormattedMessage defaultMessage="Enter this code in the field below to enable your two-step authentication:" />
          )}
        </Typography>
      );

    default:
      return null;
  }
};

export default memo(CodeMessage);
